import React, { Context, createContext, PropsWithChildren, ReactNode, useContext, useState } from 'react'
import { callApi, TApiResponse } from '../api'
import { ICountries, TCountry, TCountriesActions } from '../types'

const initialCountriesState: ICountries = {
	data: [],
	loading: false,
}

const CountriesContext: Context<{
	countries: ICountries
	actions: TCountriesActions
}> = createContext({
	countries: initialCountriesState,
	actions: {
		getList: () => {},
	},
})

export const CountriesProvider = (props: PropsWithChildren<{ children: ReactNode }>) => {
	const [loading, setLoading] = useState<boolean>(false)
	const [error, setProviderError] = useState<string | null>(null)
	const [countries, setCountries] = useState<TCountry[]>([])

	const getList = async () => {
		if (countries.length) return

		setLoading(true)
		const countriesResponse: TApiResponse = await callApi('/countries', {})

		const { data } = countriesResponse.payload

		if (countriesResponse.ok) {
			setLoading(false)
			setProviderError(null)
			setCountries(data)
		} else {
			setLoading(false)
			setProviderError(data.message || 'Cannot get Countries!')
		}
	}

	const actions: TCountriesActions = { getList }

	return (
		<CountriesContext.Provider value={{ countries: { data: countries, loading, error }, actions }}>
			{props.children}
		</CountriesContext.Provider>
	)
}

export const useCountriesContext: () => {
	countries: ICountries
	actions: TCountriesActions
} = () => {
	return useContext(CountriesContext)
}
